import React from "react";
import TableCell from "../../common/ui/TableCell";

export default function PhotoBoardHeader({ board, onChange, editing }) {
  if (!board) return null;

  return (
    <div className="overflow-hidden">
      <table className="w-full text-sm table-fixed">
        {/* 📌 열 너비 고정 */}
        <colgroup>
          <col className="w-32" />
          <col className="w-[33%]" />
          <col className="w-32" />
          <col className="w-[33%]" />
        </colgroup>

        <tbody className="divide-y">
          {/* 제목 */}
          <tr>
            <TableCell
              label="제목"
              editing={editing}
              colSpan={3}
              input={
                <input
                  type="text"
                  className="input-base w-full"
                  value={board.title || ""}
                  onChange={(e) => onChange("title", e.target.value)}
                />
              }
              value={board.title}
            />
          </tr>

          {/* 작성자 + 작성일 */}
          <tr>
            <TableCell label="작성자" value={board.created_by ?? "-"} />

            <TableCell
              label="작성일"
              value={
                board.date
                  ? new Date(board.date).toLocaleDateString("ko-KR")
                  : "-"
              }
            />
          </tr>

          {/* 프로젝트 */}
          <tr>
            <TableCell
              label="프로젝트"
              colSpan={3}
              value={board.project_name ?? "-"}
            />
          </tr>
        </tbody>
      </table>
    </div>
  );
}
